import { providentFundMiddleware } from './provident-fund-middleware';

export const providentFundMiddlewares = [providentFundMiddleware];
